import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';




const CkEditorBlog = ({ value = '', onChange }) => {
    return (
        <>
            <CKEditor
                editor={ ClassicEditor }
                data={value}
                onReady={ editor => {                    
                    
                } }
                onChange={ ( event, editor ) => {
                    const data = editor.getData();
                    if (onChange) {
                        onChange(data);
                    }
                } }
                onBlur={ ( event, editor ) => {
                    
                } }
                onFocus={ ( event, editor ) => {
                    
                } }
            /> 
        </>
    );
};

export default CkEditorBlog;